/** Placeholder URLs for onboarding help actions — replace with marketing/support links when available. */
const ONBOARDING_HELP_LINKS = {
    watchVideo: "https://wa.me/+8801858581774",
    whatsApp: "https://wa.me/+8801858581774",
    bookDemo: "https://calendly.com/officialshakeel2003/30min",
};

export default ONBOARDING_HELP_LINKS;
